module.exports = "https://static.energy5.com/_next/static/images/sliderEvCharging-884dd7a2d664eb91858e6aa1ea6af247.webp";